module.exports = __webpack_public_path__ + "media/bootstrap-icons/badge-8k-fill-93d8ac5d.svg";